/**
 * User-owned wp-content paths omitted by Playground ZIP exports before format
 * version 2.
 *
 * This list exists only to restore paths missing from old, partial archives.
 * Current exports contain all user-owned plugins and themes.
 */
export const wpContentPathsExcludedFromLegacyExports = [
	'plugins/akismet',
	'plugins/hello.php',
	'plugins/wordpress-importer',
	'themes/twentytwenty',
	'themes/twentytwentyone',
	'themes/twentytwentytwo',
	'themes/twentytwentythree',
	'themes/twentytwentyfour',
	'themes/twentytwentyfive',
	'themes/twentytwentysix',
] as const;
